/**
 * 메일용 호환 wrapper — 공통 RichTextEditor 로 위임.
 * 기존 import 경로(`./components/TiptapBodyEditor`) 호환을 위해 유지.
 */
import React from "react";
import RichTextEditor from "../../../../component/common/RichTextEditor";

export default function TiptapBodyEditor(props) {
    return <RichTextEditor {...props} />;
}
